import { useState } from "react";
import { track } from "../utils/analytics";
import "./ExportCsvButton.css";

/**
 * 내 기록을 표 파일로 받는다. 책과 문장이 함께 쓴다.
 *
 * 서버를 부르지 않는다 — 화면에 이미 있는 목록을 그대로 쓴다.
 * 남의 행성에서는 내지 않는다(부르는 쪽에서 isMe 일 때만 그린다).
 * 남의 기록을 파일로 뽑아 돌리는 건 다른 이야기다.
 *
 * @param build     () => CSV 문자열. 누를 때 만든다 — 열어 두기만 한 사람에게
 *                  매 렌더마다 수백 줄을 이어 붙이게 할 이유가 없다.
 * @param fileName  받을 파일 이름
 * @param count     버튼에 적을 개수
 * @param noun      "권" · "개" 처럼 세는 말
 * @param event     분석 이벤트 이름
 */
export default function ExportCsvButton({ build, fileName, count, label, noun = "개", event }) {
  const [msg, setMsg] = useState("");
  if (!count) return null;

  const save = () => {
    try {
      const blob = new Blob([build()], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      /* 바로 지우면 사파리가 받다 말고 끊는다. 잠깐 두었다 지운다. */
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      track(event, { count });
      setMsg(`${count}${noun}를 받았어요`);
    } catch (e) {
      console.error("내보내기 실패:", e?.message);
      setMsg("받지 못했어요");
    }
    setTimeout(() => setMsg(""), 3000);
  };

  return (
    <div className="export-books">
      <button className="export-books-btn" onClick={save}>
        ⬇ {label} <b>{count}</b>
      </button>
      {msg && <span className="export-books-msg">{msg}</span>}
    </div>
  );
}
